var map = {
	"./arr-down.svg": 1340,
	"./back.svg": 6052,
	"./camera.svg": 6760,
	"./chart.svg": 1080,
	"./check-line.svg": 9132,
	"./clients.svg": 6788,
	"./clock.svg": 8436,
	"./close.svg": 8097,
	"./complete.svg": 8220,
	"./cross.svg": 6048,
	"./edit.svg": 176,
	"./emailicon.svg": 5904,
	"./folder.svg": 9972,
	"./google-icon.svg": 5143,
	"./invisible.svg": 4092,
	"./logout.svg": 2256,
	"./mail.svg": 164,
	"./message.svg": 5464,
	"./name.svg": 1948,
	"./open.svg": 1864,
	"./padlock.svg": 8008,
	"./palette.svg": 6540,
	"./password.svg": 1488,
	"./pause.svg": 8708,
	"./play.svg": 1768,
	"./plus.svg": 232,
	"./rub.svg": 7652,
	"./settings.svg": 7020,
	"./share.svg": 2048,
	"./trash.svg": 5668,
	"./upload.svg": 9828,
	"./users.svg": 9256,
	"./visible-open.svg": 7068,
	"./vk-icon.svg": 4101,
	"./yandex_icon.svg": 5716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4688;